/* eslint-disable */
import React, { useState, useEffect } from 'react';
import styles from '../StaffingCost/staffingCost.module.scss';
import EditIcon from '../../../../../Assets/images/svg/dar_pencil.svg';
import NoDataFound from '../../../../../Assets/images/svg/dar_no_new_file.svg';
import MagnifyingGlass from '../../../../../Assets/images/svg/dar_magnifying.svg';
import DataGridComponent from '../../../Dashboard/Efforts/scopeDataGrid';
import Duration from '../../../../../Assets/images/svg/dar_duration.svg';
import { Button } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import collapseIcon from '../../../../../Assets/images/svg/dar_purple_dropdown.svg';
import SearchDropdown from '../../../../../Components/Dropdown/dropdown';
import { useSnackbar } from '../../../../../Components/Snackbar/snackBarProvider';
import UseAxios from '../../../../../Api/http/http';
import { useLocation } from 'react-router-dom';
import { staffingCostList, updateStaffingCost} from '../../../../../Api/request/dealFinancial';

const verticalOptions = [
  { id: 1, name: 'App Mod' },
  { id: 2, name: 'Data Mod' },
  { id: 3, name: 'Infra Mod' },
];

const allocationOptions = [
  { id: 1, name: '10' },
  { id: 2, name: '50' },
  { id: 3, name: '100' },
];

const StaffingCost = () => {
  const [rows, setRows] = useState([]);
  const { snackbarOpen } = useSnackbar();
  const [isEdit, setIsEdit] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [rowId, setRowId] = useState(null);
  const [expandedRows, setExpandedRows] = useState({});
  const [totalStaffingCost, setTotalStaffingCost] = useState(0);
  const [dealName, setDealName] = useState('');
  const [totalEfforts, setTotalEfforts] = useState(0);

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };

  const query = useQuery();
  const DEAL_ID = parseInt(query.get('id'), 10);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await UseAxios(staffingCostList({}, 1, 11, DEAL_ID));
        if (response.data) {
          const data = response.data?.data?.list || [];
          const transformedRows = data.map((scope, scopeIndex) => ({
            id: scope.scopeId || uuidv4(),
            srNo: scopeIndex + 1,
            task: scope.task,
            items: scope.items.map((item) => ({
              id: item.skillsetId,
              resource: item.resource,
              experience: item.experience,
              location: item.location,
              count: item.count,
              vertical: item.vertical,
              duration: item.duration,
              allocation: item.allocation,
              cost: item.cost,
              staffingCostId: item.staffingCostId,
            })),
            isEditing: false,
          }));
          setRows(transformedRows);
          setTotalStaffingCost(response.data.data.totalStaffingCosts);
          setDealName(response.data.data.dealDetails.dealName);
          setTotalEfforts(response.data.data.dealDetails.totalEfforts);
        } else {
          console.error('Response data is undefined');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        if (error.response) {
          console.error('Error response data:', error.response.data);
        }
        snackbarOpen('Oops! Please try again', 'warning');
      }
    };

    fetchData();
  }, [DEAL_ID]);

  useEffect(() => {
    if (isEdit) {
      setIsEdit(false);
    }
  }, [rows]);

  const handleRowEnter = (e) => {
    const rowId = Number(e.currentTarget.dataset.id);
    setRowId(rowId);
  };

  const handleRowOut = () => {
    setRowId(null);
  };

  const handleSearch = (event) => {
    setSearchText(event.target.value.toLowerCase());
  };

  const handleCollapse = (rowId) => {
    setExpandedRows((prevExpandedRows) => ({
      ...prevExpandedRows,
      [rowId]: !prevExpandedRows[rowId],
    }));
  };

  const filteredRows = searchText
    ? rows.filter(
        (row) =>
          row.task?.toLowerCase().includes(searchText.toLowerCase()) ||
          row.items?.some((item) =>
            [
              'task',
              'resource',
              'location',
              'experience',
              'count',
              'vertical',
              'duration',
              'allocation',
              'cost',
            ].some((field) => {
              const value = item[field];
              return String(value || '')
                .toLowerCase()
                .includes(searchText.toLowerCase());
            })
          )
      )
    : rows;

  const updateItems = (items, itemId, field, value) => {
    return items.map((item) =>
      item.id === itemId ? { ...item, [field]: value } : item
    );
  };

  const handleChangeInput = (e, rowId, itemId, field) => {
    const value = e.target.value?.name || e.target.value;
    setRows((prevRows) =>
      prevRows.map((row) => {
        if (row.id !== rowId) return row;
        return {
          ...row,
          items: updateItems(row.items, itemId, field, value),
        };
      })
    );
  };

  const handleSave = async (id) => {
    const row = rows.find((row) => row.id === id);
    if (!row?.items?.length) {
      console.error('Invalid row or items data');
      return;
    }

    const payload = row.items.map((item) => ({
      skillsetId: item.id,
      verticalId: verticalOptions.find((vert) => vert.name === item.vertical)
        ?.id,
      duration: item.duration,
      allocation: item.allocation,
      staffingCostId: item.staffingCostId,
    }));

    try {
      const staffingCostId = row.items[0].staffingCostId;
      if (!staffingCostId) {
        return;
      }
      const response = await UseAxios(updateStaffingCost(DEAL_ID, payload));
      setTotalStaffingCost(response.data.data.totalStaffingCost);
      setRows((prevRows) =>
        prevRows.map((row) =>
          row.id === id ? { ...row, isEditing: false, isEdit: false } : row
        )
      );
      snackbarOpen('Data Updated successfully', 'success');
    } catch (error) {
      console.error('Error updating staffing cost:', error);
      if (error.response) {
        console.error('Error response data:', error.response.data);
        snackbarOpen(`Error: ${error.response.data.message}`, 'warning');
      } else {
        snackbarOpen('Oops! Something went wrong', 'warning');
      }
    }
  };
  const getRowUpdated = (row, originalData) => {
    if (row.isEdit) {
      return {
        ...originalData,
        isEditing: false,
        isEdit: false,
      };
    }

    return {
      ...row,
      items: row.items.filter((item) => typeof item.id === 'number'),
      isEditing: false,
    };
  };

  const handleEdit = (id) => {
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.id === id
          ? { ...row, isEditing: true, isEdit: true, originalData: { ...row } }
          : row
      )
    );
  };

  const handleCancel = (id) => {
    setRows((prevRows) => {
      const targetRow = prevRows.find((r) => r.id === id);
      if (!targetRow) return prevRows;

      return prevRows.map((row) => {
        if (row.id !== id) return row;
        return getRowUpdated(row, row.originalData);
      });
    });
  };

  const newRowTemplate = {
    vertical: '',
    duration: '',
    allocation: '',
  };

  const isRowUnchanged = (row) => {
    return row.items.some(
      (item) =>
        item.Vertical === newRowTemplate.vertical ||
        item.duration === newRowTemplate.duration ||
        item.allocation === newRowTemplate.allocation
    );
  };

  const getSelectedValues = (value, options) => {
    return options.find((option) => option.name === String(value)) || null;
  };

  const getDisplayItem = (items, rowId, expandedRows, field) => {
    if (!items.length) {
      return '-';
    }
    const itemToDisplay = expandedRows[rowId] ? items : items.slice(0, 1);

    return itemToDisplay.map((item) => (
      <div className={styles.taskItems} key={item.id}>
        {item?.[field] || '-'}
      </div>
    ));
  };

  const columns = [
    {
      field: 'srNo',
      headerName: 'Sr. No.',
      minWidth: 90,
      maxWidth: 90,
      flex: 0.1,
      disableColumnMenu: true,
      sortable: false,
      cellClassName: styles.srNoCell,
    },
    {
      field: 'task',
      headerName: 'Task',
      minWidth: 140,
      flex: 0.4,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) =>
        params.row.isEditing ? (
          <div className={styles.taskDiv}>
            <div className={styles.saveCancelOuterDiv}>
              <label className={styles.taskLabel}>{params.row.task}</label>
              <div
                className={styles.saveCancelDiv}
                style={{ marginTop: `${params.row.items.length * 30}px` }}
              >
                <Button
                  className={styles.saveCancelButton}
                  variant="contained"
                  onClick={() => handleSave(params.row.id)}
                  sx={{
                    backgroundColor: '#6B5CE8 !important',
                    color: 'white !important',
                    '&.Mui-disabled': {
                      opacity: 0.4,
                    },
                  }}
                  disabled={isRowUnchanged(params.row)}
                  startIcon={<CheckIcon />}
                ></Button>
                <Button
                  className={styles.saveCancelButton}
                  variant="outlined"
                  style={{
                    color: '#6B5CE8',
                    borderColor: '#6B5CE8',
                  }}
                  onClick={() => handleCancel(params.row.id)}
                  startIcon={<ClearIcon />}
                ></Button>
              </div>
            </div>
          </div>
        ) : (
          <label className="saved-value">{params.row.task}</label>
        ),
    },
    {
      field: 'resource',
      headerName: 'Role',
      minWidth: 120,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => {
        const itemToDisplay = expandedRows[params.row.id]
          ? params.row.items
          : params.row.items.slice(0, 1);

        return params.row.isEditing ? (
          <div style={{ display: 'flex', flexDirection: 'column' ,marginTop: '0.4rem'}}>
            {params.row.items.map((item) => (
              <div className={styles.staffingsetDiv} key={item.id}>
                <div className={styles.taskItems}>{item?.resource || '-'}</div>
              </div>
            ))}
          </div>
        ) : (
          <label className="saved-value">
            {!params.row.items.length
              ? '-'
              : itemToDisplay.map((item) => (
                  <div className={styles.staffingsetDiv} key={item.id}>
                    <div className={styles.taskItems}>
                      {item?.resource || '-'}
                    </div>
                  </div>
                ))}
          </label>
        );
      },
    },
    {
      field: 'location',
      headerName: 'Location',
      minWidth: 130,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const itemToDisplay = expandedRows[params.row.id]
          ? params.row.items
          : params.row.items.slice(0, 1);

        return params.row.isEditing ? (
          <div style={{ display: 'flex', flexDirection: 'column', marginTop: '0.4rem' }}>
            {params.row.items.map((item) => (
              <div className={styles.staffingsetDiv} key={item.id}>
                <div className={styles.taskItems}>{item?.location || '-'}</div>
              </div>
            ))}
          </div>
        ) : (
          <label className="saved-value">
            {!params.row.items.length
              ? '-'
              : itemToDisplay.map((item) => (
                  <div className={styles.staffingsetDiv} key={item.id}>
                    <div className={styles.taskItems}>
                      {item?.location || '-'}
                    </div>
                  </div>
                ))}
          </label>
        );
      },
    },
    {
      field: 'experience',
      headerName: 'Experience',
      minWidth: 130,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const itemToDisplay = expandedRows[params.row.id]
          ? params.row.items
          : params.row.items.slice(0, 1);

        return params.row.isEditing ? (
          <div style={{ display: 'flex', flexDirection: 'column', marginTop: '0.4rem' }}>
            {params.row.items.map((item) => (
              <div className={styles.staffingsetDiv} key={item.id}>
                <div className={styles.taskItems}>
                  {item?.experience || '-'}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <label className="saved-value">
            {!params.row.items.length
              ? '-'
              : itemToDisplay.map((item) => (
                  <div className={styles.staffingsetDiv} key={item.id}>
                    <div className={styles.taskItems}>
                      {item?.experience || '-'}
                    </div>
                  </div>
                ))}
          </label>
        );
      },
    },
    {
      field: 'count',
      headerName: 'Count',
      minWidth: 130,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const itemToDisplay = expandedRows[params.row.id]
          ? params.row.items
          : params.row.items.slice(0, 1);

        return params.row.isEditing ? (
          <div style={{ display: 'flex', flexDirection: 'column', marginTop: '0.4rem' }}>
            {params.row.items.map((item) => (
              <div className={styles.staffingsetDiv} key={item.id}>
                <div className={styles.taskItems}>{item?.count || '-'}</div>
              </div>
            ))}
          </div>
        ) : (
          <label className="saved-value">
            {!params.row.items.length
              ? '-'
              : itemToDisplay.map((item) => (
                  <div className={styles.staffingsetDiv} key={item.id}>
                    <div className={styles.taskItems}>{item?.count || '-'}</div>
                  </div>
                ))}
          </label>
        );
      },
    },
    {
      field: 'vertical',
      headerName: 'Vertical',
      minWidth: 105,
      flex: 0.3,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) =>
        params.row.isEditing ? (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {params.row.items.map((item) => (
              <SearchDropdown
                key={item.id} // Add a unique key prop here
                searchBox={false}
                placeholder="Select"
                options={verticalOptions}
                onChange={(e) =>
                  handleChangeInput(e, params.row.id, item.id, 'vertical')
                }
                value={getSelectedValues(item.vertical, verticalOptions)}
                dropdownCss={styles.textbox}
              />
            ))}
          </div>
        ) : (
          <label className="saved-value">
            {getDisplayItem(
              params.row.items,
              params.row.id,
              expandedRows,
              'vertical'
            )}
          </label>
        ),
    },
    {
      field: 'duration',
      headerName: 'Duration',
      minWidth: 105,
      flex: 0.3,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const isExpanded = expandedRows[params.row.id];
        const isEditing = params.row.isEditing;

        const itemsToDisplay =
          isExpanded || isEditing
            ? params.row.items
            : params.row.items.slice(0, 1);

        return (
          <div className={styles.durationContainer}>
            {isEditing ? (
              <div className={styles.durationColumn}>
                {itemsToDisplay.map((item) => (
                  <div key={item.id} className={styles.durationRow}>
                    <input
                      type="text"
                      value={item.duration ?? ''}
                      onChange={(e) =>
                        handleChangeInput(e, params.row.id, item.id, 'duration')
                      }
                      className={styles.durationInput}
                      min="0"
                    />
                    <span className={styles.durationText}>Month/s</span>
                  </div>
                ))}
              </div>
            ) : (
              <div className={styles.durationText}>
                {itemsToDisplay.length > 0
                  ? itemsToDisplay.map((item) => (
                      <div className={styles.durationItems} key={item.id}>
                        {item.duration !== null && item.duration !== undefined
                          ? `${item.duration} ${
                              item.duration == 1 ? 'Month' : 'Months'
                            }`
                          : '-'}
                      </div>
                    ))
                  : '-'}
              </div>
            )}
          </div>
        );
      },
    },
    {
      field: 'allocation',
      headerName: 'Allocation',
      minWidth: 105,
      sortable: false,
      flex: 0.3,
      disableColumnMenu: true,
      renderCell: (params) =>
        params.row.isEditing ? (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {params.row.items.map((item) => (
              <SearchDropdown
                key={item.id}
                searchBox={true}
                placeholder="Select"
                options={allocationOptions}
                onChange={(e) =>
                  handleChangeInput(e, params.row.id, item.id, 'allocation')
                }
                value={getSelectedValues(item.allocation, allocationOptions)}
                dropdownCss={styles.textbox}
              />
            ))}
          </div>
        ) : (
          <label className="saved-value">
            {getDisplayItem(
              params.row.items,
              params.row.id,
              expandedRows,
              'allocation'
            )}
          </label>
        ),
    },
    {
      field: 'cost',
      headerName: 'Cost',
      Width: 130,
      disableColumnMenu: true,
      sortable: false,
      headerClassName: styles['staffingCosts-header'],
      renderCell: (params) => {
        const itemToDisplay = expandedRows[params.row.id]
          ? params.row.items
          : params.row.items.slice(0, 1);

        return params.row.isEditing ? (
          <div className={styles['staffingCosts-cell']} style={{ display: 'flex' , marginTop: '0.4rem'}}>
            {params.row.items.map((item) => (
              <div className={styles.staffingsetDiv} key={item.id}>
                <div className={styles.taskItems}>{item?.cost || '-'}</div>
              </div>
            ))}
          </div>
        ) : (
          <label className={styles['staffingCosts-cell']}>
            {!params.row.items.length
              ? '-'
              : itemToDisplay.map((item) => (
                  <div className={styles.staffingsetDiv} key={item.id}>
                    <div className={styles.taskItems}>{item?.cost || '-'}</div>
                  </div>
                ))}
          </label>
        );
      },
    },
    {
      headerClassName: styles.actionColumn,
      cellClassName: styles.actionCell,
      maxWidth: 70,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <div className={styles.mobileActionIcons}>
          {params.row?.items?.length != 0 ? (
            <>
              {!params.row?.isEditing && (
                <button
                  className="role-action-edit-icon"
                  aria-label="Edit"
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                  }}
                  onClick={() => handleEdit(params.row.id)}
                >
                  <img src={EditIcon} alt="Edit" />
                </button>
              )}
            </>
          ) : (
            <button
              className="role-action-edit-icon"
              aria-label="Edit"
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
              }}
              onClick={() => handleAddRow(params.row.id)}
            >
              <img src={EditIcon} alt="Edit" />
            </button>
          )}
          {params.row?.items?.length > 1 && !params.row?.isEditing && (
            <button
              className="role-action-edit-icon"
              aria-label="Collapse"
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
              }}
              onClick={() => handleCollapse(params.row.id)}
            >
              <img
                src={collapseIcon}
                style={{
                  transform: expandedRows[params.row.id]
                    ? 'rotate(180deg)'
                    : 'none',
                }}
                alt="Edit"
              />
            </button>
          )}
        </div>
      ),
    },
  ];

  const handleAddRow = (rowId) => {
    const newItem = {
      id: uuidv4(),
      vertical: '',
      count: 1,
      experience: '',
      duration: '',
      allocation: '',
      cost: '',
    };

    setRows((prevRows) =>
      prevRows.map((row) => {
        if (row.id === rowId) {
          return {
            ...row,
            items: [...row.items, newItem],
            isEditing: true,
          };
        }
        return row;
      })
    );
  };

  return (
    <div className={styles.skillsetCostMainDiv}>
      <div className={styles.staffingCcostSummaryDiv1}>
        <span className={styles.summaryTitle}> Staffing Cost Summary</span>
        <span className={styles.dividers}></span>
        <div className={styles.logoSection}>
          <div className={styles.companyInfo}>
            <span className={styles.title}>{dealName}</span>
            <div className={styles.durationDiv}>
              <img src={Duration} alt="Duration" />
              <span>{totalEfforts} Man Days</span>
            </div>
          </div>
        </div>
        <div className={styles.staffingCostDiv}>
          <div className={styles.staffingCostHeader}>
            <span>Total Staffing Cost</span>
            <div className={styles.staffingCostAmt}>
              <span>₹ {totalStaffingCost}</span>
            </div>
          </div>
          <div className={styles.staffingCostAmtDiV}></div>
        </div>
      </div>

      <div className={styles.staffingCcostSummaryDiv2}>
        <div className={styles.staffingCostMain}>
          <span>Staffing Cost</span>
          <div className={styles.staffingCostSearchAdd}>
            <div className={styles.staffingCostSearch}>
              <img src={MagnifyingGlass} alt="Search" />
              <input
                id="travel-cost-search-input"
                type="text"
                placeholder="Search..."
                onChange={handleSearch}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.skillsetCostGrid}>
        <DataGridComponent
          dataRows={filteredRows}
          dataColumns={columns}
          pageSize={10}
          getRowHeight={() => 'auto'}
          isEdit={setRows}
          sortFilterColumns={[]}
          onRowSelectionChange={() => {}}
          checkboxDisabled={false}
          rowHeight={150}
          noDataImage={NoDataFound}
          noDataTitle="No Skillset added yet."
          noDataSubTitle="Please add it to view here"
          hideSeparator={true}
          editStateHeight={110}
          dataGridCss={styles.dataGrid}
          getRowId={(row) => row.id}
          handleRowEnter={handleRowEnter}
          handleRowLeave={handleRowOut}
        />
      </div>
    </div>
  );
};

export default StaffingCost;
